"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/bookusSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BookusSectionAccordionsItem = {
    key: Key | null | undefined;
    /** Detected variants: "accordion-collapse collapse show" | "accordion-collapse collapse" */
    className: string;
    /** Detected variants: "collapseSix" | "collapseSeven" */
    id: string;
    /** Detected variants: "headingTen" | "headingEleven" */
    h30Id: string;
    /** Detected variants: "Our Vision" | "Our Mission" */
    link0Text: ReactNode;
    /** Detected variants: "collapseSeven" */
    ariaControls?: string;
    /** Detected variants: "true" */
    ariaExpanded?: boolean;
    /** Detected variants: "accordion-button" | "accordion-button collapsed" */
    link0ClassName: string;
    /** Detected variants: "#collapseSix" | "#collapseSeven" */
    dataBsTarget: string;
    /** Detected variants: "accordion-item" */
    divClassName?: string;
    /** Detected variants: "#faq-details" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName2?: string;
    /** Detected variants: "We envision a community where everyone has access to high-quality healthcare and the resources they need to lead healthy, fulfilling lives." */
    p0Text?: ReactNode;
    /** Detected variants: "accordion-header" */
    h30ClassName?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
};

type BookusSection12ZoomInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-md-12 wow zoomInUp" | "col-sm-6 wow zoomInUp" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/book-01.jpg" | "/Templates/Doccure/img/book-02.jpg" | "/Templates/Doccure/img/book-03.jpg" */
    src: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
};

type BookusSection36sItem = {
    key: Key | null | undefined;
    /** Detected variants: "book-icon bg-primary" | "book-icon bg-orange" | "book-icon bg-cyan" */
    className: string;
    /** Detected variants: "isax isax-search-normal5" | "isax isax-security-user5" | "isax isax-calendar5" */
    i0ClassName: string;
    /** Detected variants: "Search For Doctors" | "Check Doctor Profile" | "Schedule Appointment" */
    h30Text: ReactNode;
    /** Detected variants: "Search for a doctor based on specialization, location, or availability for your Treatements" | "Explore detailed doctor profiles on our platform to make informed healthcare decisions." | "After choose your preferred doctor, select a convenient time slot, & confirm your appointment." */
    p0Text: ReactNode;
    /** Detected variants: "01" | "02" | "03" */
    h40Text: ReactNode;
    /** Detected variants: "col-xl-3 col-md-6" */
    divClassName?: string;
    /** Detected variants: "book-item wow zoomInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "book-info" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "way-icon" */
    div2ClassName?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/way-icon.svg" */
    src?: string;
    /** Detected variants: "book-no" */
    div3ClassName?: string;
};
export type HomeOneBookusSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BookusSection36sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div2ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BookusSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div3H40H4Props?: Partial<ComponentProps<"h4">> | ((item: BookusSection36sItem) => Partial<ComponentProps<"h4">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: BookusSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
    divH30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BookusSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BookusSection12ZoomInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    sectionDiv0Div0Div0Div0Div0ClassName?: string;
    /** Default: "" */
    sectionDiv0Div0Div0Div0Link0LinkDataFancybox?: string;
    /** Default: "#" */
    sectionDiv0Div0Div0Div0Link0LinkHref?: string;
    sectionDiv0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Play Video · Play Video ·" */
    sectionDiv0Div0Div0Div0Link0Button0ButtonDataText?: string;
    sectionDiv0Div0Div0Div0Link0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Link0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Link0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "About Us" */
    sectionDiv0Div0Div1Div0Div0DivText?: ReactNode;
    /** Default: "We are committed to" */
    sectionDiv0Div0Div1Div0H20H2Text?: ReactNode;
    /** Default: "understanding your" */
    sectionDiv0Div0Div1Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div1Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "unique" */
    sectionDiv0Div0Div1Div0H20Span0SpanText?: ReactNode;
    /** Default: "needs and delivering care." */
    sectionDiv0Div0Div1Div0H20Span0SpanText2?: ReactNode;
    /** Default: "As a trusted health as a trusted healthcare provider in our community, we are passionate about promoting health and wellness beyond the clinic." */
    sectionDiv0Div0Div1Div0P0PText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div1DivDataWowDuration?: string;
    /** Default: "faq-details" */
    sectionDiv0Div0Div1Div1Div0DivId?: string;
    sectionDiv0Div1Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div1Div0Div3Div0DivDataWowDuration?: string;
    /** Default: "Get Your Solution" */
    sectionDiv0Div1Div0Div3Div0Div1H30H3Text?: ReactNode;
    /** Default: "Discuss your health with the doctor and the personalized advice & with solution." */
    sectionDiv0Div1Div0Div3Div0Div1P0PText?: ReactNode;
    /** Default: 4 */
    sectionDiv0Div1Div0Div3Div0Div2H40H4Text?: ReactNode;
    /** Default: "element" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/aboutus-bg.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "element" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/aboutus-bg-one.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    bookusSectionAccordions: BookusSectionAccordionsItem[];
    bookusSection12ZoomInUps: BookusSection12ZoomInUpsItem[];
    bookusSection36s: BookusSection36sItem[];
    bookusSectionAccordionsItemWrapper?: (item: BookusSectionAccordionsItem, content: ReactNode) => ReactNode;
    bookusSectionAccordionsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bookusSectionAccordionsLinkVisible?: boolean;
    bookusSectionAccordionsLinkRenderer?: (item: BookusSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    bookusSectionAccordionsH3Visible?: boolean;
    bookusSectionAccordionsH3Renderer?: (item: BookusSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    bookusSectionAccordionsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BookusSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    bookusSectionAccordionsH3Props?: Partial<ComponentProps<"h3">> | ((item: BookusSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
    bookusSection12ZoomInUpsItemWrapper?: (item: BookusSection12ZoomInUpsItem, content: ReactNode) => ReactNode;
    bookusSection12ZoomInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bookusSection12ZoomInUpsImageVisible?: boolean;
    bookusSection12ZoomInUpsImageRenderer?: (item: BookusSection12ZoomInUpsItem, defaultNode: ReactNode) => ReactNode;
    bookusSection12ZoomInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BookusSection12ZoomInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bookusSection36sItemWrapper?: (item: BookusSection36sItem, content: ReactNode) => ReactNode;
    bookusSection36sRenderer?: (defaultNode: ReactNode) => ReactNode;
    bookusSection36sImageVisible?: boolean;
    bookusSection36sImageRenderer?: (item: BookusSection36sItem, defaultNode: ReactNode) => ReactNode;
    bookusSection36sH3Visible?: boolean;
    bookusSection36sH3Renderer?: (item: BookusSection36sItem, defaultNode: ReactNode) => ReactNode;
    bookusSection36sH4Visible?: boolean;
    bookusSection36sH4Renderer?: (item: BookusSection36sItem, defaultNode: ReactNode) => ReactNode;
    bookusSection36sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BookusSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bookusSection36sH3Props?: Partial<ComponentProps<"h3">> | ((item: BookusSection36sItem) => Partial<ComponentProps<"h3">>);
    bookusSection36sH4Props?: Partial<ComponentProps<"h4">> | ((item: BookusSection36sItem) => Partial<ComponentProps<"h4">>);
};

const HomeOneBookusSectionGenerated: FC<HomeOneBookusSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0Link0Button0ButtonDataText = "Play Video · Play Video ·",
    sectionDiv0Div0Div0Div0Link0Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Link0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Link0Button0ButtonProps,
    sectionDiv0Div0Div0Div0Link0LinkDataFancybox = "",
    sectionDiv0Div0Div0Div0Link0LinkHref = "#",
    sectionDiv0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div1Div0Div0DivText = "About Us",
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0H20H2Text = "We are committed to",
    sectionDiv0Div0Div1Div0H20H2Text2 = "understanding your",
    sectionDiv0Div0Div1Div0H20H2Visible,
    sectionDiv0Div0Div1Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0H20H2Props,
    sectionDiv0Div0Div1Div0H20Span0SpanText = "unique",
    sectionDiv0Div0Div1Div0H20Span0SpanText2 = "needs and delivering care.",
    sectionDiv0Div0Div1Div0P0PText = "As a trusted health as a trusted healthcare provider in our community, we are passionate about promoting health and wellness beyond the clinic.",
    sectionDiv0Div0Div1Div1Div0DivId = "faq-details",
    sectionDiv0Div0Div1Div1DivDataWowDuration = "1s",
    sectionDiv0Div1Div0Div3Div0Div1H30H3Text = "Get Your Solution",
    sectionDiv0Div1Div0Div3Div0Div1P0PText = "Discuss your health with the doctor and the personalized advice & with solution.",
    sectionDiv0Div1Div0Div3Div0Div2H40H4Text = 4,
    sectionDiv0Div1Div0Div3Div0DivDataWowDuration = "1s",
    sectionImageWithBasePath0ImageAlt = "element",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/aboutus-bg.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "element",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/aboutus-bg-one.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0Div2ImageWithBasePath0ImageProps,
    divDiv0Div3H40H4Props,
    divH30H3Props,
    divH30Link0LinkProps,
    divImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div0Div0Div0ClassName,
    sectionDiv0Div1Div0ClassName,
    bookusSectionAccordions,
    bookusSection12ZoomInUps,
    bookusSection36s,
    bookusSectionAccordionsItemWrapper,
    bookusSectionAccordionsRenderer,
    bookusSectionAccordionsLinkVisible,
    bookusSectionAccordionsLinkRenderer,
    bookusSectionAccordionsH3Visible,
    bookusSectionAccordionsH3Renderer,
    bookusSectionAccordionsLinkProps,
    bookusSectionAccordionsH3Props,
    bookusSection12ZoomInUpsItemWrapper,
    bookusSection12ZoomInUpsRenderer,
    bookusSection12ZoomInUpsImageVisible,
    bookusSection12ZoomInUpsImageRenderer,
    bookusSection12ZoomInUpsImageProps,
    bookusSection36sItemWrapper,
    bookusSection36sRenderer,
    bookusSection36sImageVisible,
    bookusSection36sImageRenderer,
    bookusSection36sH3Visible,
    bookusSection36sH3Renderer,
    bookusSection36sH4Visible,
    bookusSection36sH4Renderer,
    bookusSection36sImageProps,
    bookusSection36sH3Props,
    bookusSection36sH4Props,
}) => {
    return (
        <>
            <section className="bookus-section bg-dark section">
                <div className="container">
                    <div className={sectionDiv0Div0ClassName ?? "row align-items-center g-4"}>
                        <div className="col-lg-6">
                            <div className="bookus-img pe-lg-4">
                                <div className={sectionDiv0Div0Div0Div0Div0ClassName ?? "row g-3"}>
                                    {renderCollectionNode(
                                        bookusSection12ZoomInUps,
                                        (item: BookusSection12ZoomInUpsItem) => (
                                            <div className={item.className} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                                {renderItemNode(bookusSection12ZoomInUpsImageVisible, bookusSection12ZoomInUpsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "img"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof bookusSection12ZoomInUpsImageProps === "function" ? bookusSection12ZoomInUpsImageProps(item) : (bookusSection12ZoomInUpsImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </div>
                                        ),
                                        bookusSection12ZoomInUpsItemWrapper,
                                        bookusSection12ZoomInUpsRenderer
                                    )}
                                </div>
                                {renderNode(sectionDiv0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Link0LinkHref} data-fancybox={sectionDiv0Div0Div0Div0Link0LinkDataFancybox} {...(sectionDiv0Div0Div0Div0Link0LinkProps ?? {})}>
                                        {renderNode(sectionDiv0Div0Div0Div0Link0Button0ButtonVisible, sectionDiv0Div0Div0Div0Link0Button0ButtonRenderer, (
                                            <button className="animate-button" data-text={sectionDiv0Div0Div0Div0Link0Button0ButtonDataText} {...(sectionDiv0Div0Div0Div0Link0Button0ButtonProps ?? {})}>
                                                <p className="button-text" />
                                                <span className="button-circle">
                                                    <i className="isax isax-play" />
                                                </span>
                                            </button>
                                        ))}
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="section-header section-header-one wow zoomInUp" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                                <div className="title">{sectionDiv0Div0Div1Div0Div0DivText}</div>
                                {renderNode(sectionDiv0Div0Div1Div0H20H2Visible, sectionDiv0Div0Div1Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div1Div0H20H2Props ?? {})}>
                                        {" "}
                                        {sectionDiv0Div0Div1Div0H20H2Text}
                                        <br />
                                        {sectionDiv0Div0Div1Div0H20H2Text2}
                                        {" "}
                                        <span className="text-gradient">
                                            {sectionDiv0Div0Div1Div0H20Span0SpanText}
                                            <br />
                                            {sectionDiv0Div0Div1Div0H20Span0SpanText2}
                                            {" "}
                                        </span>
                                    </h2>
                                ))}
                                <p>{sectionDiv0Div0Div1Div0P0PText}</p>
                            </div>
                            <div className="faq-info wow zoomInUp" data-wow-duration={sectionDiv0Div0Div1Div1DivDataWowDuration}>
                                <div className="accordion" id={sectionDiv0Div0Div1Div1Div0DivId}>
                                    {renderCollectionNode(
                                        bookusSectionAccordions,
                                        (item: BookusSectionAccordionsItem) => (
                                            <div className={item.divClassName ?? "accordion-item"} key={item.key}>
                                                {renderItemNode(bookusSectionAccordionsH3Visible, bookusSectionAccordionsH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "accordion-header"} id={item.h30Id} {...(typeof bookusSectionAccordionsH3Props === "function" ? bookusSectionAccordionsH3Props(item) : (bookusSectionAccordionsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                        {renderItemNode(bookusSectionAccordionsLinkVisible, bookusSectionAccordionsLinkRenderer, item, (
                                                            <SmartLink href={item.href ?? "#"} className={item.link0ClassName} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded} {...(typeof bookusSectionAccordionsLinkProps === "function" ? bookusSectionAccordionsLinkProps(item) : (bookusSectionAccordionsLinkProps ?? {}))} {...(typeof divH30Link0LinkProps === "function" ? divH30Link0LinkProps(item) : (divH30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                        ))}
                                                    </h3>
                                                ))}
                                                <div id={item.id} className={item.className} data-bs-parent={item.dataBsParent ?? "#faq-details"}>
                                                    <div className={item.div0ClassName ?? "accordion-body"}>
                                                        <div className={item.div0ClassName2 ?? "accordion-content"}>
                                                            <p>{item.p0Text ?? "We envision a community where everyone has access to high-quality healthcare and the resources they need to lead healthy, fulfilling lives."}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ),
                                        bookusSectionAccordionsItemWrapper,
                                        bookusSectionAccordionsRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bookus-sec">
                        <div className={sectionDiv0Div1Div0ClassName ?? "row g-5"}>
                            {renderCollectionNode(
                                bookusSection36s,
                                (item: BookusSection36sItem) => (
                                    <div className={item.divClassName ?? "col-xl-3 col-md-6"} key={item.key}>
                                        <div className={item.div0ClassName ?? "book-item wow zoomInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                            <div className={item.className}>
                                                <i className={item.i0ClassName} />
                                            </div>
                                            <div className={item.div1ClassName ?? "book-info"}>
                                                {renderItemNode(bookusSection36sH3Visible, bookusSection36sH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof bookusSection36sH3Props === "function" ? bookusSection36sH3Props(item) : (bookusSection36sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                ))}
                                                <p>{item.p0Text}</p>
                                            </div>
                                            <div className={item.div2ClassName ?? "way-icon"}>
                                                {renderItemNode(bookusSection36sImageVisible, bookusSection36sImageRenderer, item, (
                                                    <SmartImage src={item.src ?? "/Templates/Doccure/img/icons/way-icon.svg"} alt={item.alt ?? "img"} {...(typeof bookusSection36sImageProps === "function" ? bookusSection36sImageProps(item) : (bookusSection36sImageProps ?? {}))} {...(typeof divDiv0Div2ImageWithBasePath0ImageProps === "function" ? divDiv0Div2ImageWithBasePath0ImageProps(item) : (divDiv0Div2ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </div>
                                            <div className={item.div3ClassName ?? "book-no"}>
                                                {renderItemNode(bookusSection36sH4Visible, bookusSection36sH4Renderer, item, (
                                                    <h4 {...(typeof bookusSection36sH4Props === "function" ? bookusSection36sH4Props(item) : (bookusSection36sH4Props ?? {}))} {...(typeof divDiv0Div3H40H4Props === "function" ? divDiv0Div3H40H4Props(item) : (divDiv0Div3H40H4Props ?? {}))}>{item.h40Text}</h4>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ),
                                bookusSection36sItemWrapper,
                                bookusSection36sRenderer
                            )}
                        </div>
                    </div>
                </div>
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="element-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="element-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
                ))}
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeOneBookusSectionGenerated;
